module.exports = __webpack_public_path__ + "img/bag_2.7bfe5969.svg";